// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".form-title {\n  background-color: #F5F5F7;\n  text-align: left;\n  color: #555555;\n  padding-bottom: 23px;\n  padding-top: 23px;\n  padding-left: 12px;\n}\n", ""]);
// Exports
module.exports = exports;
